const CollectType = {
  Required: "REQUIRED",
  Optional: "OPTIONAL"
};

export { CollectType };
//# sourceMappingURL=collect-type.mjs.map
